// extracted by mini-css-extract-plugin
module.exports = {"content":"Notice_style_content__iX7QC","noteText":"Notice_style_noteText__1tbVF","bottom":"Notice_style_bottom__M2YXv","date":"Notice_style_date__23DBk"};